module.exports = __webpack_public_path__ + "./docs/img/big-icon-references.a6e551ca1e7df707645ab3667edebd93.svg";